var map = {
	"./bootstrap.png": "e896",
	"./cart3.svg": "57c0",
	"./coin.svg": "d023",
	"./css3.png": "7de7",
	"./gb.svg": "a6ac",
	"./git.png": "14d3",
	"./html5.png": "8308",
	"./it.svg": "c4bc",
	"./javascript.png": "8d85",
	"./jquery.png": "f183",
	"./laravel.png": "401c",
	"./mysql.png": "a010",
	"./palette.svg": "2d72",
	"./php.png": "c891",
	"./sass.png": "2b8f",
	"./search.svg": "22ee",
	"./tailwind.png": "8913",
	"./vuejs.png": "61fa",
	"./walter-with-duck.jpg": "cb33",
	"./walter.png": "c05a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";